export const trainBuyingCn = {
    shangpingxinxi:"商品信息",
    peixunkechengxinxi:"培训课程信息",
    xianmaixianyong:"现买现用",
    dingdanheji:"订单合计（含运费）",
    kechengjine:"课程金额",
    yingfuzongjia:"应付总价",
    payTitle:"订单交易成功，立即观看完整视频！",
    guankankecheng:"返回课程详情"
}


// WEBPACK FOOTER //
// ./src/lang/home/trainBuying/indexCn.js